import { AutoSizer, List } from "react-virtualized";
import { Point as GeoPoint } from "protos/geo/geo";
import { Point } from "./Point";
import { useFarmExplorer } from "portal/state/store";
import React, { CSSProperties, FC, ReactNode, useMemo } from "react";

interface PointListProps {
  points: (GeoPoint | undefined)[];
}
export const PointList: FC<PointListProps> = ({ points }: PointListProps) => {
  const { pointsById } = useFarmExplorer();

  const derefedPoints: GeoPoint[] = useMemo(() => {
    const derefed = [];
    for (const [i, p] of points.entries()) {
      if (p?.id?.id) {
        let pt = pointsById?.[p.id.id];
        if (pt) {
          pt = { ...pt };
          pt.name = `${i} ${pt.name}`;
          derefed.push(pt);
        }
      }
    }
    return derefed;
  }, [pointsById, points]);

  const renderRow = ({
    style,
    index,
    key,
  }: {
    style: CSSProperties;
    index: number;
    key: string;
  }): ReactNode => {
    const point = derefedPoints[index];
    return (
      <div key={key} style={style}>
        {point && <Point key={`${point.id?.id}-${index}-p`} point={point} />}
      </div>
    );
  };

  return (
    <div className="h-96">
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height}
            width={width}
            rowHeight={60}
            rowCount={derefedPoints.length}
            rowRenderer={renderRow}
          />
        )}
      </AutoSizer>
    </div>
  );
};
